var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktopView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 433,
    viewBox: "0 0 532 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.636 0H48.3636C21.7636 0 0 21.65 0 48.1111V336.778C0 363.239 21.7636 384.889 48.3636 384.889H169.273V433H362.727V384.889H483.636C510.236 384.889 531.758 363.239 531.758 336.778L532 48.1111C532 21.65 510.236 0 483.636 0ZM483.636 336.778H48.3636V48.1111H483.636V336.778Z",
    fill: "#323232"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopView);
export default __webpack_public_path__ + "static/media/desktop-view.f150193a.svg";
export { ForwardRef as ReactComponent };